import { useSelector } from 'react-redux';
import { TetrazolioItem, TetrazolioListResponse } from '../../../../../../../services/sementes/tetrazolio';
import ListaTetrazolioItem from './ListaTetrazolioItem';
import PaginacaoSementes from '../PaginacaoSementes';
import { selectTopBarState } from '../../../../../../../components/Topbar/topBarSlice';

interface Props {
  items: TetrazolioItem[];
  loading: boolean;
  error: string | null;
  meta: TetrazolioListResponse['meta'] | null;
  onPageChange: (page: number) => void;
}

export default function ListaTetrazolio({
  items, loading, error, meta, onPageChange,
}: Props) {
  const { currentProdutor } = useSelector(selectTopBarState);

  if (!currentProdutor) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '3rem 2rem',
        color: '#666',
        fontSize: '16px',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        margin: '2rem 0',
      }}
      >
        <i className="pi pi-info-circle" style={{ fontSize: '2rem', marginBottom: '1rem', display: 'block' }} />
        <strong>Nenhum produtor selecionado</strong>
        <p style={{ marginTop: '0.5rem', fontSize: '14px' }}>
          Selecione um produtor no cabeçalho para visualizar as análises
        </p>
      </div>
    );
  }

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>Erro: {error}</div>;
  }

  return (
    <div className="table">
      <div className="header">
        <div>Requerente</div>
        <div>N° Amostra</div>
        <div>Espécie</div>
        <div>Data de Entrada</div>
        <div>Data de Análise</div>
        <div>Status</div>
        <div>Progresso</div>
        <div />
      </div>
      {
        items.map((item) => (
          <ListaTetrazolioItem
            key={item.id}
            id={item.id}
            produtor={item.produtor}
            nAmostra={item.nAmostra}
            especie={item.especie}
            dataEntrada={item.dataEntrada}
            dataAnalise={item.dataAnalise}
            status={item.status}
            progresso={item.progresso}
            repeticaoRejeitada={item.repeticaoRejeitada}
          />
        ))
      }

      {meta && (
        <PaginacaoSementes
          currentPage={meta.currentPage}
          totalPages={meta.totalPages}
          totalItems={meta.totalItems}
          perPage={meta.perPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
}
